import React from "react";
import styled from "styled-components";
import style from "../assets/style.png";

const Project = () => {
  return (
    <Container>
      <Content>
        {/* Left Section */}
        <Section>
          <ContentBox>
            <Heading>Architectural Design</Heading>
            <Description>
            Access award-winning home designs by Shibanee & Kamal Architects and customize interiors to suit your lifestyle, functional needs, and aesthetic preferences using our design platform.
            </Description>
          </ContentBox>
          <ContentBox>
            <Heading>Construction, Interiors & Furniture</Heading>
            <Description>
            Access to quality construction and craftsmanship from Total Environment, including interior finishes, furniture, 
            cabinetry & kitchens, along with Lifetime Maintenance support.
            </Description>
          </ContentBox>
          <ContentBox>
            <Heading>Cobbled Streets</Heading>
            <Description>
            Our streets feature durable hand-crafted cobblestones, blending with nature, reducing vehicle speed without speed-breakers, and designed with slopes to prevent rain puddles.
            </Description>
          </ContentBox>
        </Section>

        <CenterImage>
          <Image
            className="animate__animated animate__zoomIn"
            src={style}
            alt="Project"
          />
        </CenterImage>

        <Section>
          <ContentBox>
            <Heading>Walking Paths</Heading>
            <Description>
            Experience invigorating walks through wooded paths, surrounded by trees, birds, squirrels, butterflies, and nature’s beauty, offering inspiration and serenity throughout the community.
            </Description>
          </ContentBox>
          <ContentBox>
            <Heading>Cycling Tracks</Heading>
            <Description>
            Another wonderful way to experience nature is on a bicycle. Cycling tracks running through the property allow 
            you to enjoy nature on a bicycle. 
            </Description>
          </ContentBox>
          <ContentBox>
            <Heading>Property Management</Heading>
            <Description>
            Total Environment ensures lifelong maintenance of common areas, excluding your plot unless built through us, providing continuous support and care for your community's shared spaces and surroundings.
            </Description>
          </ContentBox>
        </Section>
      </Content>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 20px;
  background-color: #f9f9f9;

  @media (max-width: 480px) {
    width: 100%;
  }
`;


const Content = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1200px;

  @media (max-width: 1024px) {
    flex-direction: column;
    gap: 30px;
  }
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 30%;

  @media (max-width: 768px) {
    width: 90%;
    align-items: center;
  }
`;

const ContentBox = styled.div`
  background: #fff;
  border-radius: 10px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  padding: 15px;
  text-align: center;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
  }
`;

const Heading = styled.h2`
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
  font-family: sans-serif;
  color: #333;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const Description = styled.p`
  font-size: 14px;
  color: #666;
  font-family: sans-serif;

  @media (max-width: 768px) {
    font-size: 14px;
  }
      @media (max-width: 480px) {
    font-size: 14px;
  }
`;

const CenterImage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40%;
  position: relative;

  @media (max-width: 1024px) {
    width: 60%;
  }

  @media (max-width: 768px) {
    width: 80%;
  }

  @media (max-width: 480px) {
    width: 100%;
  }
`;

const Image = styled.img`
  width: 400px;
  height: 500px;
  border-radius: 10px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease, filter 0.3s ease;

  @media (max-width: 768px) {
    width: 80%;
     height: 90%;
  }

  @media (max-width: 480px) {
    width: 90%;
    height: 90%;
  }
`;


export default Project;
